import { useState, useEffect } from 'react';

const navLabels = ['About', 'Services', 'Values', 'Contact'];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-950'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-10 md:px-16 h-20 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-8 h-8 flex items-center justify-center">
            <div className={`w-6 h-6 rounded-sm border-2 rotate-45 transition-colors duration-300 ${
              scrolled ? 'border-foreground-800' : 'border-foreground-900'
            }`}></div>
          </div>
        </div>
        <div className="hidden md:flex items-center gap-10">
          {navLabels.map((label) => (
            <span
              key={label}
              className="text-sm tracking-widest uppercase text-foreground-800 font-medium whitespace-nowrap"
            >
              {label}
            </span>
          ))}
        </div>
      </div>
    </nav>
  );
}